import { ConfirmModal } from '../AdminModal';

const BulkActionHost = ({ bulk }) => {
  if (!bulk?.pending) return null;

  return (
    <ConfirmModal
      title={bulk.pending.title}
      confirmLabel={bulk.pending.confirmLabel || 'Confirm'}
      danger={bulk.pending.danger !== false}
      busy={bulk.busy}
      error={bulk.error}
      onCancel={bulk.cancel}
      onConfirm={bulk.confirm}
    >
      {bulk.pending.body}
    </ConfirmModal>
  );
};

export default BulkActionHost;
